import { INITIAL_REDUX_STATE } from 'vio-constants';
const userSettingsState = {
    awsLayer: INITIAL_REDUX_STATE.DEFAULT_USER_SETTINGS.AWS_LAYER,
    azureLayer: INITIAL_REDUX_STATE.DEFAULT_USER_SETTINGS.AZURE_LAYER,
    chartFrequency: INITIAL_REDUX_STATE.DEFAULT_USER_SETTINGS.CHART_FREQUENCY,
    chartRange: INITIAL_REDUX_STATE.DEFAULT_USER_SETTINGS.CHART_RANGE,
    defaultOrganization: INITIAL_REDUX_STATE.DEFAULT_USER_SETTINGS.DEFAULT_ORGANIZATION,
    googleLayer: INITIAL_REDUX_STATE.DEFAULT_USER_SETTINGS.GOOGLE_LAYER,
    homePage: INITIAL_REDUX_STATE.DEFAULT_USER_SETTINGS.HOME_PAGE,
    mapTheme: INITIAL_REDUX_STATE.DEFAULT_USER_SETTINGS.MAP_THEME,
    overlaysMenu: INITIAL_REDUX_STATE.DEFAULT_USER_SETTINGS.OVERLAYS_MENU,
    requestingModifyUserSettings: false,
    requestingUserSettings: false
};
export default userSettingsState;
